// Admin/Tabs/SupporterGalleryTab.jsx
import { useEffect, useState } from "react";
import "../Styles/SupporterImages.css";
import { useConfig } from "../../context/ConfigContext";

export default function SupporterGalleryTab() {
  const { config } = useConfig();
  const apiBase = config.apiUrl;
  const apiKey = config.REACT_APP_API_KEY;

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const loadPending = async () => {
    setLoading(true);
    setErr("");
    setMsg("");
    try {
      const res = await fetch(`${apiBase}/admin/supporter-gallery/pending`, {
        headers: { "Api-Key": apiKey }, credentials: "include"
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to load pending images");
      setItems(data.items || []);
    } catch (e) {
      console.error(e);
      setErr(e.message || "Failed to load images");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPending();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const act = async (id, action) => {
    setErr("");
    setMsg("");
    try {
      const res = await fetch(`${apiBase}/admin/supporter-gallery/${id}/${action}`, {
        method: "POST",
        headers: { "Api-Key": apiKey }, credentials: "include"
      });
      const data = await res.json();
      if (!res.ok || data.error) throw new Error(data.error || "Action failed");
      setMsg(`Image ${action === "approve" ? "approved" : "rejected"}.`);
      setItems((items) => items.filter((it) => it._id !== id));
    } catch (e) {
      console.error(e);
      setErr(e.message || "Action failed");
    }
  };

  return (
    <div className="card-grid">
      <section className="card">
        <h2>Supporter Photos – Pending Approval</h2>

        {err && <p className="muted small error-text">{err}</p>}
        {msg && <p className="muted small">{msg}</p>}

        {loading && <p className="muted small">Loading…</p>}

        <div className="supporterimages-scroll">
          {!loading && items.length === 0 && (
            <p className="muted small">No pending supporter uploads.</p>
          )}

          {items.map((img) => (
            <article className="supporter-admin-item" key={img._id}>
              <figure className="supporter-admin-thumb">
                <img
                  src={img.url}
                  alt={`Supporter upload by ${img.uploaderName || "Supporter"}`}
                />
              </figure>
              <div className="supporter-admin-meta">
                <p className="small">
                  Uploaded by <strong>{img.uploaderName || "Supporter"}</strong>
                </p>
                <p className="small muted">
                  {img.createdAt
                    ? new Date(img.createdAt).toLocaleString()
                    : ""}
                </p>
                <p className="small muted">
                  Caption (on site): <strong>Uploaded by a supporter</strong>
                </p>
              </div>
              <div className="supporter-admin-actions">
                <button
                  className="btn primary btn-sm"
                  onClick={() => act(img._id, "approve")}
                >
                  Approve
                </button>
                <button
                  className="btn danger btn-sm"
                  onClick={() => act(img._id, "reject")}
                >
                  Reject
                </button>
              </div>
            </article>
          ))}
        </div>

        <div className="actions">
          <button className="btn ghost" onClick={loadPending} disabled={loading}>
            {loading ? "Refreshing…" : "Refresh"}
          </button>
        </div>
      </section>
    </div>
  );
}